import type { FormEvent } from "react";

import { AccountController } from "@repo/baseCloud";
import { log } from "@repo/helpers";
import { MfaTypePage } from "@repo/ui";
import { useContext, useEffect, useState } from "react";
import { Redirect, useHistory } from "react-router-dom";

import { AuthContext } from "./context";
import { useAuthSettings, useMfaTypes } from "./hooks";

export function TLPCloudMfaTypePage() {
	const { username, selectedMfaType, setSelectedMfaType } = useContext(AuthContext);
	const [disabled, setDisabled] = useState<boolean>(false);
	const [error, setError] = useState<string>("");
	const [loggingIn, setLoggingIn] = useState<boolean>(false);
	const history = useHistory();
	const authSettingsQuery = useAuthSettings(username);
	const typesQuery = useMfaTypes(username);

	useEffect(() => {
		document.title = "TLP Cloud - Select Multi Factor Type";
	}, []);

	async function submit(event: FormEvent<HTMLFormElement>) {
		event.preventDefault();

		setDisabled(true);
		setLoggingIn(true);
		await login();
	}

	function handleError(message?: string, error?: any) {
		log(error, "error");
		setError(message ?? "An error occurred while logging in");
		setDisabled(false);
		setLoggingIn(false);
	}

	async function login() {
		try {
			const response = await AccountController.requestMfaCode(username, selectedMfaType);

			if (!response.success) {
				handleError(response.message);
			} else {
				history.push("/OTP");
			}
		} catch (error) {
			handleError(error);
		}
	}

	if (!username) {
		return <Redirect to="/Login" />;
	}

	return (
		<MfaTypePage
			types={typesQuery.data ?? []}
			type={selectedMfaType}
			setType={setSelectedMfaType}
			submitFunction={submit}
			disabled={disabled}
			loading={loggingIn}
			error={error}
			goBack={() => history.goBack()}
			backgroundImage={authSettingsQuery.data?.backgroundImage}
			appLogo={authSettingsQuery.data?.companyLogo}
		/>
	);
}
